import { render, staticRenderFns } from "./VisitMessage.vue?vue&type=template&id=2b210a74&"
import script from "./VisitMessage.vue?vue&type=script&lang=ts&"
export * from "./VisitMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports